import { session_wechat } from "@tencent/midas-util"

export class WechatAccount {
  init(opt) {
    return new Promise((resolve, reject) => {
      if (opt.openid && opt.openkey) {
        let loginState = new session_wechat({
          openid: opt.openid,
          accessToken: opt.openkey,
          appid: opt.wx_appid
        })
        resolve({ loginState: loginState })
      } else {
        reject("无登录态")
      }
    })
  }
}
